import { createContext, useContext, useLayoutEffect, useRef, useState } from "react";

const AccordionContext = createContext({ expanded: false, onChange: () => {} });

export function Accordion({ expanded, onChange, children }) {
  return (
    <AccordionContext.Provider value={{ expanded, onChange }}>
      {children}
    </AccordionContext.Provider>
  );
}

export function AccordionSummary({ multiline, children }) {
  const { expanded, onChange } = useContext(AccordionContext);
  const classes = [
    "ui-acc-summary",
    multiline ? "ui-acc-summary--multiline" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} onClick={() => onChange(!expanded)}>
      <span className="ui-acc-summary__text">{children}</span>
      <svg
        className={`ui-acc-summary__chevron ${expanded ? "ui-acc-summary__chevron--open" : ""}`}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

// max-height по scrollHeight — тот же подход, что в telegram-ui: контент
// может быть любым, анимация раскрытия через transition в CSS.
export function AccordionContent({ children }) {
  const { expanded } = useContext(AccordionContext);
  const ref = useRef(null);
  const [maxHeight, setMaxHeight] = useState(expanded ? "inherit" : 0);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    setMaxHeight(expanded ? node.scrollHeight : 0);
  }, [expanded]);

  return (
    <div className="ui-acc-content" ref={ref} style={{ maxHeight }}>
      {children}
    </div>
  );
}
